export const sources={avif:"__VITE_ASSET__CxqMUn30__ 80w"};export const img={src:"__VITE_ASSET__C5xQQVAd__",w:80,h:11};export default{sources:sources,img:img};